var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"counter-bar"},[_c('div',{staticClass:"counter-bar-label"},[_c('span',{staticClass:"mr-1"},[_vm._v(_vm._s(_vm.label))]),_c('span',{staticClass:"text-small text-gray"},[_vm._v("("+_vm._s(_vm.value)+")")])]),_c('st-bar',{attrs:{"percent":_vm.percent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }